import { ref, computed } from 'vue';

export default function useModalNavigation(viewTitles = {}) {
  const activeView = ref(null);
  const transitionName = ref('modal-push-forward');
  const modalBody = ref(null);
  const activeViewTitle = computed(() => viewTitles[activeView.value] || '');

  function pushView(view) {
    if (modalBody.value) {
      modalBody.value.style.minHeight = modalBody.value.offsetHeight + 'px';
    }
    transitionName.value = 'modal-push-forward';
    activeView.value = view;
  }

  function popView() {
    transitionName.value = 'modal-push-back';
    activeView.value = null;
  }

  function onAfterEnter() {
    if (!activeView.value && modalBody.value) {
      modalBody.value.style.minHeight = '';
    }
  }

  return {
    activeView,
    transitionName,
    modalBody,
    activeViewTitle,
    pushView,
    popView,
    onAfterEnter,
  };
}
